import { render, staticRenderFns } from "./Printables.vue?vue&type=template&id=9b259ad8"
import script from "./Printables.vue?vue&type=script&lang=js"
export * from "./Printables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports